<div class="theme-ai-filters" [formGroup]="ai()">
    <h4 class="section-title">Filter Criteria</h4>
    <p class="section-subtitle">
        Named prompt slices that help classify and normalize submissions
        consistently.
        <span class="body-1">For voice/text interactives only.</span>
    </p>

    <div class="grid">
        @for (slot of slots; track slot.slot) {
            <div class="card">
                <div class="card-header">
                    <tools-badge [variant]="BadgeVariant.PILL_OUTLINE">
                        Filter {{ slot.slot }}
                    </tools-badge>
                    <span class="slot-label">Prompt Slot</span>
                </div>

                <tools-input-outline
                    label="Label"
                    placeholder="Short label (e.g., Question, Story, Shoutout)"
                    [maxLength]="labelMaxLength"
                    [formControlName]="slot.labelControl"
                ></tools-input-outline>

                <h5 class="card-title">Criteria</h5>
                <tools-textarea
                    placeholder="Describe what belongs in this category so the AI can tag it."
                    [maxLength]="criteriaMaxLength"
                    [formControlName]="slot.criteriaControl"
                ></tools-textarea>
            </div>
        }
    </div>

    <h4 class="section-title content-title">Content Configuration</h4>
    <p class="section-subtitle">
        Show-specific censorship rules, transcription vocabulary, and additional
        instructions injected into the AI analysis prompt.
    </p>

    <div class="card">
        <div class="field">
            <div class="field-header">
                <h5 class="card-title">Transcription Vocabulary</h5>
                <p class="card-subtitle">
                    Enter names, terms, or phrases the AI should spell exactly
                    as written in transcriptions. Separate entries with commas.
                </p>
            </div>
            <tools-textarea
                placeholder="e.g., Jose Mangin, Kreator, RZA"
                [maxLength]="vocabularyMaxLength"
                formControlName="transcriptionVocabularyCriteria"
            ></tools-textarea>
        </div>
    </div>
</div>
